import type { ProductsState } from '../types';

export const getPageNumbers = (productsByPage: ProductsState['pages']) => {
  return Object.keys(productsByPage)
    .map((pageNo) => parseInt(pageNo))
    .sort((a, b) => a - b);
};

export const getPreviousPageNumberNotLoaded = (productsByPage: ProductsState['pages']) => {
  const pageNumbers = getPageNumbers(productsByPage);
  const firstPageNumber = pageNumbers[0];

  return firstPageNumber > 1 ? firstPageNumber - 1 : null;
};

export const getNextPageNumberNotLoaded = (
  productsByPage: ProductsState['pages'],
  totalPages: number,
) => {
  const pageNumbers = getPageNumbers(productsByPage);
  const lastPageNumber = pageNumbers[pageNumbers.length - 1];

  return lastPageNumber < totalPages ? lastPageNumber + 1 : null;
};
